<template>
  <div
    class="slider-verify-container"
    :class="{ verified: isVerified, dragging: isDragging }"
  >
    <div class="slider-verify-track" ref="trackRef">
      <div
        class="slider-verify-bg"
        :class="{ 'verified-bg': isVerified }"
        :style="{ width: sliderLeft + 'px' }"
      />
      <div
        v-if="!isVerified"
        class="slider-verify-instruction"
        aria-hidden="true"
      >
        <span class="slider-verify-shimmer-text">{{ verifyText }}</span>
      </div>
      <div
        v-if="!isVerified"
        class="slider-verify-slider"
        :class="{ dragging: isDragging }"
        :style="{ transform: 'translateX(' + sliderLeft + 'px)' }"
        @mousedown="handleMouseDown"
        @touchstart="handleTouchStart"
      >
        <AppIcon name="doubleArrowRight" size="md" class="slider-double-arrow" aria-label="" />
      </div>
      <div
        v-if="showHint"
        class="slider-verify-hint-inline"
        :class="{ 'is-failure': !isVerified }"
        role="status"
      >
        <i v-if="isVerified" class="material-icons slider-hint-check" aria-hidden="true">check_circle</i>
        <span>{{ hintText }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppIcon from '@/shared/components/AppIcon.vue'
import { useSliderVerify } from '@/shared/composables/useSliderVerify'

defineProps({
  verifyText: {
    type: String,
    default: '请按住滑块，拖动到最右边',
  },
})

const emit = defineEmits(['verify-success'])

const {
  trackRef,
  sliderLeft,
  isDragging,
  isVerified,
  showHint,
  hintText,
  handleMouseDown,
  handleTouchStart,
  reset,
} = useSliderVerify(emit)

defineExpose({ reset })
</script>

<style scoped src="@/shared/styles/SliderVerify.css"></style>
